import {isEmpty} from 'lodash';
import PropTypes from 'prop-types';
import * as React from 'react';
import {Collapse} from 'react-bootstrap';

import FilterNodeLabel from './FilterNodeLabel';
import FilterNodeRemoveButton from './FilterNodeRemoveButton';
import FilterNodeTick from './FilterNodeTick';
import styles from './FilterNodeTypeWrapper.less';
import {DateRangeFilter, Filter} from 'src/js/lib/filtering';
import {FilterNode as FilterNodeModel} from 'src/js/model/filters_config';

interface OwnProps {
  filter: Filter;
  isOpened?: boolean;
  node: FilterNodeModel;
  removeFilter: (filter: DateRangeFilter) => void;
  selectedFilter?: DateRangeFilter;
  setFocus: () => void;
  suppressFocus?: boolean;
  toggleOpened: () => void;
  isMui?: boolean;
}

type Props = OwnProps;

export const FilterNodeTypeWrapper: React.FC<Props> = (props) => {
  const {
    setFocus,
    suppressFocus = false,
    children,
    filter,
    isOpened = false,
    node,
    removeFilter,
    selectedFilter,
    toggleOpened,
    isMui = false,
  } = props;

  const setFocusFunction = () => {
    if (!suppressFocus) {
      setFocus();
    }
  };

  return isMui ? (
    <div>{children}</div>
  ) : (
    <span className={styles.dlFilterNodeTypeWrapper}>
      {
        // render tick only if node has children
        node.getType() ? (
          <FilterNodeTick isOpened={isOpened} toggleOpened={toggleOpened} label={node.getLabel()} />
        ) : (
          <FilterNodeLabel label={node.getLabel()} />
        )
      }
      <FilterNodeRemoveButton removeFilter={removeFilter} isVisible={!isEmpty(selectedFilter) && !node.isNotRemovable()} item={filter} />
      <Collapse in={isOpened} onEntered={setFocusFunction}>
        <div>{children}</div>
      </Collapse>
    </span>
  );
};

FilterNodeTypeWrapper.displayName = 'FilterNodeTypeWrapper';
